import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { EventUtil } from "../../util/EventUtil";
import { PageContext } from "../../service/PageContext";

export class HealioErrorModal extends Component {
  public static readonly HealioErrorEvent = "HealioErrorEvent";

  constructor(element: HTMLElement, pageContext: PageContext) {
    super(element, pageContext);
    window.addEventListener(HealioErrorModal.HealioErrorEvent, ev =>
      this.showModal());
  }
  public static triggerHealioErrorModalEvent() : void {
    window.dispatchEvent(
      EventUtil.createCustomEvent(
          HealioErrorModal.HealioErrorEvent, null
          ));
  }

  private showModal(): void {
    $(this._element).modal("show");

  }

}



ComponentFactory.registerComponent("HealioErrorModal",
HealioErrorModal);
